// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
//import store from './vuex/store'
Vue.use(Vuex)
//引入ele-ui 组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//公共js文件
import Public from './util/public'

Vue.prototype.Public = Public;
Vue.use(Public)

//引入axios
import Axios from 'axios'
//修改原型链，全局使用axios,这样之后可在每个组件的methods中调用$axios命令完成数据请求
Vue.prototype.$axios=Axios

//二次封装axios
import api from './util/axios'
Vue.prototype.$api = api

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
import router from './router'



// WEBPACK FOOTER //
// ./src/main.js